import { jsx as a, jsxs as t } from "react/jsx-runtime";
import "react";
import { classes as i } from "../../utils/helpers.js";
import { s as $ } from "../../sub-CLNYDReX.mjs";
import { f as m } from "../../format-CkEOCppP.mjs";
import { a as u } from "../../add-nQBHlm6X.mjs";
import '../../assets/AirDateFormatter.css';const d = {
  "airdate-formatter__pipe": "_airdate-formatter__pipe_1ox2d_1",
  "airdate-formatter__date": "_airdate-formatter__date_1ox2d_8",
  "airdate-formatter__time-wrap": "_airdate-formatter__time-wrap_1ox2d_13"
};
function b({ airdateStr: f = null, separatorType: p = "none" }) {
  if (f === null) return /* @__PURE__ */ a("airdate-formatter", { class: "no-airdate", children: " " });
  const e = new Date(f.replace(" ", "T")), h = $(e, { hours: 1 }), o = e.getMinutes() === 0 ? "" : m(e, ":mm"), s = `${m(e, "h")}${o}${Number.parseInt(m(e, "H"), 10) < 12 ? "a" : ""}`, l = `${m(h, "h")}${o}`;
  let r = `${m(e, "ccc")}`, n = "";
  const c = new Date((/* @__PURE__ */ new Date()).toLocaleString("en-US", { timeZone: "America/New_York" })), _ = u(c, { days: 1 });
  switch (`${c.getFullYear()}${c.getMonth()}${c.getDate()}` == `${e.getFullYear()}${e.getMonth()}${e.getDate()}` ? r = "Today" : `${_.getFullYear()}${_.getMonth()}${_.getDate()}` == `${e.getFullYear()}${e.getMonth()}${e.getDate()}` ? r = "Tomorrow" : n = `${m(e, "LLL d")}`, p) {
    case "pipe":
      return /* @__PURE__ */ t("airdate-formatter", { children: [
        /* @__PURE__ */ a("span", { className: i([d["airdate-formatter__date"], "airdate-formatter__date"]), children: r === "Today" || r === "Tomorrow" ? r : `${r}, ${n}` }),
        /* @__PURE__ */ a("span", { className: i([d["airdate-formatter__pipe"], "airdate-formatter__pipe"]), children: " | " }),
        /* @__PURE__ */ t("span", { className: "airdate-formatter__time-wrap", children: [
          /* @__PURE__ */ a("span", { className: "airdate-formatter__time", children: s }),
          "/",
          o !== "" ? /* @__PURE__ */ a("br", {}) : null,
          /* @__PURE__ */ t("span", { className: "airdate-formatter__central-time", children: [
            l,
            /* @__PURE__ */ a("span", { children: "c" })
          ] })
        ] })
      ] });
    case "line-break":
      return /* @__PURE__ */ t("airdate-formatter", { children: [
        /* @__PURE__ */ a("div", { className: i([d["airdate-formatter__day"], "airdate-formatter__day"]), children: r }),
        /* @__PURE__ */ a("div", { className: i([d["airdate-formatter__date"], "airdate-formatter__date"]), children: n }),
        /* @__PURE__ */ t("div", { className: i([d["airdate-formatter__time-wrap"], "airdate-formatter__time-wrap"]), children: [
          /* @__PURE__ */ a("span", { className: "airdate-formatter__time", children: s }),
          "/",
          o !== "" ? /* @__PURE__ */ a("br", {}) : null,
          /* @__PURE__ */ t("span", { className: "airdate-formatter__central-time", children: [
            l,
            /* @__PURE__ */ a("span", { children: "c" })
          ] })
        ] })
      ] });
    case "single-line-break":
      return /* @__PURE__ */ t("airdate-formatter", { children: [
        /* @__PURE__ */ t("div", { className: i([d["airdate-formatter__day"], "airdate-formatter__day"]), children: [
          r,
          " ",
          /* @__PURE__ */ a("span", { className: i([d["airdate-formatter__date"], "airdate-formatter__date"]), children: n })
        ] }),
        /* @__PURE__ */ t("div", { className: i([d["airdate-formatter__time-wrap"], "airdate-formatter__time-wrap"]), children: [
          /* @__PURE__ */ a("span", { className: "airdate-formatter__time", children: s }),
          "/",
          o !== "" ? /* @__PURE__ */ a("br", {}) : null,
          /* @__PURE__ */ t("span", { className: "airdate-formatter__central-time", children: [
            l,
            /* @__PURE__ */ a("span", { children: "c" })
          ] })
        ] })
      ] });
    case "none":
    default:
      return /* @__PURE__ */ t("airdate-formatter", { children: [
        /* @__PURE__ */ a("span", { className: i([d["airdate-formatter__date"], "airdate-formatter__date"]), children: r === "Today" || r === "Tomorrow" ? r : `${r}, ${n}` }),
        " ",
        /* @__PURE__ */ t("span", { className: i([d["airdate-formatter__time-wrap"], "airdate-formatter__time-wrap"]), children: [
          /* @__PURE__ */ a("span", { className: "airdate-formatter__time", children: s }),
          "/",
          /* @__PURE__ */ t("span", { className: "airdate-formatter__central-time", children: [
            l,
            /* @__PURE__ */ a("span", { children: "c" })
          ] })
        ] })
      ] });
  }
}
export {
  b as AirDateFormatter,
  b as default
};
